import iconECI from "../assets/img/elcorteingles.jpg";
import iconKUO from "../assets/img/kuo_avatar.png";
import iconUverify from "../assets/img/uVerifyMarcaNegativa.png";
import iconBanorte from "../assets/img/banorte_avatar.png";
import iconSTR from "../assets/img/stratesys.png";
import iconAcelen from "../assets/img/acelen_avatar.png";
import iconAngloBrazil from "../assets/img/anglo_brasil.png";

interface SubscriptionIcon {
  [key: string]: string;
}

export const IconsBySubscription: SubscriptionIcon = {
  ECI: iconECI,
  KUO: iconKUO,
  UVS: iconUverify,
  STR: iconSTR,
  BEL: iconUverify,
  BAN: iconBanorte,
  ACL: iconAcelen,
  AAOPBR: iconAngloBrazil,
};
